"use strict";

const body = document.querySelector('body');

// RWF Builder - Product Page
const builderSet = document.querySelector('.kt-rwf-builder-set');

if (builderSet) {
  const flCbInputs = document.querySelectorAll('.kt-rwf-builder-cb');
  let RwfAtc = document.querySelector('.kt-rwf-atc');
  let atcLink = '';
  let count = 1;
  let qtyInps = document.querySelectorAll('.kt-rwf-builder-qty');

  const priceMoney = document.querySelector('price-money');
  const builderMain = document.querySelector('.kt-rwf-builder');
  const defPrice = Number(builderMain.dataset.price.replace('$', ''));

  qtyInps.forEach(qtyInp => {
    qtyInp.value = 1;
  });

  const allQtyInps = document.querySelectorAll('.kt-rwf-builder-qty');

  const updateSet = function () {
    let updatedPrice = 0;
    let RwfAtc = document.querySelector('.kt-rwf-atc');

    const mainItemFrag = RwfAtc.href.split('updates')[1].split('=')[0];
    let mainItemFragQty = RwfAtc.href.split('updates')[1].split('=')[1].replace('&', '');
    let newAtcLink = `/cart/update?updates${mainItemFrag}=${mainItemFragQty}`;

    flCbInputs.forEach((flCbInput, i) => {
      if (flCbInput.checked) {
        const itemQty = flCbInput.parentElement.querySelector('.kt-rwf-builder-qty').value;
        const itemPrice = Number(flCbInput.dataset.price.replace('$', '')) * itemQty;

        newAtcLink = newAtcLink.concat(`&updates[${flCbInput.value}]=${itemQty}`);
        updatedPrice = updatedPrice + itemPrice;
      }
    });

    RwfAtc.href = newAtcLink;
    updatedPrice = updatedPrice + defPrice;

    const priceStringSpl = String(updatedPrice).split('.');
    const suff = priceStringSpl[1] == undefined ? '00' : priceStringSpl[1];

    const priceHTML = `<bdi><span class="price__prefix">$</span>${priceStringSpl[0]}<sup class="price__suffix">.${suff}</sup></bdi>`;
    priceMoney.innerHTML = priceHTML;
  };

  allQtyInps.forEach(allQtyInp => {
    allQtyInp.addEventListener('change', function () {
      updateSet();
    });
  });

  flCbInputs.forEach(flCbInput => {
    flCbInput.addEventListener('change', function () {
      const thisQtyInp = this.parentElement.querySelector('.kt-rwf-builder-qty');

      thisQtyInp.value = 1;

      if (this.checked) {
        thisQtyInp.classList.remove('rdc-d-none');
      } else {
        thisQtyInp.classList.add('rdc-d-none');
      }

      updateSet();
    });
  });
}

//--END--//

fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    console.log(cart);
  });


//--Product Flow - Customized Order--//

document.addEventListener('DOMContentLoaded', function () {
  const dateInput = document.getElementById('another-date');

  if (!dateInput) return;

  const blockedDates = [
    '2026-12-25',
    '2026-12-26',
    '2027-01-01'
  ];

  function formatDate(year, month, day) {
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  function addDays(dateString, days) {
    const [year, month, day] = dateString.split('-').map(Number);

    const date = new Date(Date.UTC(year, month - 1, day));

    date.setUTCDate(date.getUTCDate() + days);

    return formatDate(
      date.getUTCFullYear(),
      date.getUTCMonth() + 1,
      date.getUTCDate()
    );
  }

  function isSunday(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.getUTCDay() === 0;
  }

  function isBlockedDate(dateString) {
    return blockedDates.includes(dateString);
  }

  function isUnavailable(dateString) {
    return isSunday(dateString) || isBlockedDate(dateString);
  }

  function getMinimumDate() {
    const today = new Date();

    let minDate = formatDate(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    );

    while (isUnavailable(minDate)) {
      minDate = addDays(minDate, 1);
    }

    return minDate;
  }

  dateInput.min = getMinimumDate();

 const errorPopup = document.querySelector('.kh-error-popup');
const errorClose = document.querySelector('.kh-error-close');

if (errorClose) {
  errorClose.addEventListener('click', function () {
    errorPopup.classList.add('rdc-d-none');
  });
}

dateInput.addEventListener('change', function () {
  const selectedDate = this.value;

  if (!selectedDate) return;

 if (isSunday(selectedDate)) {
  errorPopup.classList.remove('rdc-d-none');

  this.value = this.min;

  deliDate = 'Today';

  const selectedDateText = document.querySelector('#tomorrow');

  if (selectedDateText) {
    selectedDateText.innerText = 'Today';
  }

  return;
}

  if (isBlockedDate(selectedDate)) {
    alert('This date is unavailable. Please select another date.');
    this.value = '';
    return;
  }

  if (selectedDate < dateInput.min) {
    alert('This date is no longer available. Please select another date.');
    this.value = '';
  }
});
});


const pfDelDate = document.querySelector('#tomorrow');
const pfMain = document.querySelector('.kh-pf-main');

let pfCards = document.querySelectorAll('.kh-pf-card-chb');
let tempCart = [];
let deliDate = 'Today';

const updateTempCart = function () {
  tempCart = [];

  if (!this.hasAttribute('checked')) {
    this.setAttribute('checked', 'true');
  } else {
    this.removeAttribute('checked');
  }

  pfCards = document.querySelectorAll('.kh-pf-card-chb');

  pfCards.forEach(pfCard => {
    if (pfCard.getAttribute('checked') == 'true') {
      tempCart.push(pfCard.closest('.kh-pf-card').children[0].value);
    }
  });
};


if (pfMain) {
  // PF Delivery Date
  const tomCon = document.querySelector('#tomorrow');

  if (tomCon) {
  const today = new Date();

  const weekday = today.toLocaleDateString('en-AU', {
    weekday: 'long'
  });

  const date = today.toLocaleDateString('en-AU');

  document.getElementById('tomorrow').textContent = `Today`;
}

  // Add all items to Cart
  const pfAtc = document.querySelector('.kh-pf-atc');
  const pfDelCal = document.querySelector('.kh-pf-cal');
  const premDelOpts = document.querySelectorAll('.kh-pf-custom-prdel input');

 deliDate = pfDelDate ? pfDelDate.innerText : 'Today';
  let premDel = "No";

  const updateDel = function () {
    premDelOpts.forEach(premDelOpt => premDelOpt.removeAttribute('checked'));
    this.setAttribute('checked', 'true');

    premDel = this.value;
  };

  if (premDelOpts[0]) {
    premDelOpts.forEach(premDelOpt => premDelOpt.addEventListener('click', updateDel));
  }

  const updateDate = function () {
    if (!pfDelCal.value) return;

    const newSelectedDate = new Date(pfDelCal.value);

    const weekday = newSelectedDate.toLocaleDateString('en-AU', {
      weekday: 'long'
    });

    const date = newSelectedDate.toLocaleDateString('en-AU');

    const todayValue = pfDelCal.min;

if (pfDelCal.value === todayValue) {
  deliDate = 'Today';
} else {
  deliDate = `${weekday}, ${date}`;
}

pfDelDate.innerText = deliDate;
    document.querySelector('.kh-pf-cal').classList.add('rdc-hide-after');
  };

  if (pfDelCal) {
    pfDelCal.addEventListener('change', updateDate);
  }

  const addItemsToCart = async function (event) {
    event.preventDefault();

    const itemsToAdd = tempCart.map((tempCartItem) => {
      return {
        id: Number(tempCartItem),
        quantity: 1
      };
    });

    const prod = {
      id: Number(pfMain.dataset.id),
      quantity: 1
    };

    const premDelItem = {
      id: 43876235444266,
      quantity: 1
    };

    const newItemsToAdd = premDel == 'Yes'
      ? [prod, ...itemsToAdd, premDelItem]
      : [prod, ...itemsToAdd];

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: newItemsToAdd
        })
      });

      if (!addResponse.ok) {
        throw new Error('Cart add failed');
      }

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Delivery Date": premDel == 'Yes' ? 'Today' : deliDate
          }
        })
      });

      if (!updateResponse.ok) {
        throw new Error('Cart update failed');
      }

      window.location.href = "/cart";

    } catch (error) {
      console.error(error);
      alert('There was an issue adding this to cart. Please try again.');
    }
  };

  pfCards.forEach(pfCard => pfCard.addEventListener('click', updateTempCart));

  if (pfAtc) {
    pfAtc.addEventListener('click', addItemsToCart);
  }
}


if (body.classList.contains('template-cart')) {
  // PF Cart
  const occMain = document.querySelector('.kh-pf-cart-msg-gen-opts');
  const useGenBtn = document.querySelector('.kh-pf-c-msg-gen-btn');
  const clsGenBtn = document.querySelector('.kh-pf-cart-msg-cls');
  const occBtns = document.querySelectorAll('.kh-pf-cart-msg-gen-opts-box span');
  const allMsgs = document.querySelectorAll('.kh-pf-msg-set > div');
  const msgsMain = document.querySelector('.kh-pf-msgs');
  const useMsgBtn = document.querySelector('.kh-pf-c-usemsg-btn');
  const genMsgBtn = document.querySelector('.kh-pf-c-gen-btn');

  const giftMsg = document.querySelector('textarea[name="gift_message"]');

  const msgInputs = document.querySelectorAll('.kh-pf-cart-msg-inputs label > *');

  let pfCards = document.querySelectorAll('.kh-pf-card-chb');

  let genCount = 1;
  let currOcc, msgSetMain, activeMsg;

  const showMessFunc = function (msgs, setMain) {
    msgs.forEach(allMsg => allMsg.classList.remove('rdc-active'));

    activeMsg = setMain.children[genCount - 1];

    activeMsg.classList.add('rdc-active');
  };

  const hideShowGen = function () {
    const isOpenBtn = this.classList.contains('kh-pf-c-msg-gen-btn');

    if (isOpenBtn) {
      occMain.classList.add('rdc-active');
    } else {
      occMain.classList.remove('rdc-active');
    }
  };

  const generateMessage = function () {
    if (currOcc !== msgSetMain.id) {
      genCount = 2;
    } else if (genCount == 3) {
      genCount = 1;
    } else {
      genCount++;
    }

    showMessFunc(allMsgs, msgSetMain);

    currOcc = msgSetMain.id;
  };

  const updateMsg = function () {
  if (this.classList.contains('kh-pf-c-usemsg-btn') && giftMsg && activeMsg) {
    giftMsg.value = activeMsg.innerText;
  }
};

  msgInputs.forEach(msgInput => {
    msgInput.addEventListener('input', updateMsg);
  });

  useMsgBtn.addEventListener('click', updateMsg);

  const updateOcc = function () {
    genCount = 1;
    msgsMain.classList.remove('rdc-d-none');
    msgSetMain = document.querySelector(`#${this.dataset.occ}`);

    showMessFunc(allMsgs, msgSetMain);

    occBtns.forEach(occBtn => {occBtn.classList.remove('rdc-active')})

    this.classList.add('rdc-active');
  };

  const noteBtn = document.querySelector('.kh-pf-cart-note-btn');
  const noteTextarea = document.querySelector('.kh-pf-cart-note-n');

  const toggleNote = function () {
    noteTextarea.classList.toggle('rdc-active');
  };

  noteBtn.addEventListener('click', toggleNote);

  let pfCartCo = document.querySelector('.kh-pf-cart-co.product-form__submit');

  const termsCb = document.querySelector('#terms');

  const updateCoBtn = function () {
  if (termsCb.checked) {
    pfCartCo.classList.add('rdc-active');
  } else {
    pfCartCo.classList.remove('rdc-active');
  }
};

updateCoBtn();

termsCb.addEventListener('change', updateCoBtn);

  const finalCartUpdate = async function (event) {
    event.preventDefault();

if (!termsCb.checked) return;

    const upItemsToAdd = tempCart.map((tempCartItem) => {
      return {
        id: Number(tempCartItem),
        quantity: 1
      };
    });

    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const updatedAttributes = {
  ...cart.attributes,
  "Message": giftMsg ? giftMsg.value : ""
};

      if (upItemsToAdd.length > 0) {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: upItemsToAdd
          })
        });

        if (!addRes.ok) {
          throw new Error('Cart add failed');
        }
      }

      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: updatedAttributes,
          note: noteTextarea.querySelector('textarea').value
        })
      });

      if (!updateRes.ok) {
        throw new Error('Cart update failed');
      }

      window.location.href = "/checkout";

    } catch (error) {
      console.error(error);
      alert('There was an issue updating the cart. Please try again.');
    }
  };

  pfCards.forEach(pfCard => pfCard.addEventListener('click', updateTempCart));

  occBtns.forEach(occBtn => occBtn.addEventListener('click', updateOcc));
  genMsgBtn.addEventListener('click', generateMessage);
  useGenBtn.addEventListener('click', hideShowGen);
  clsGenBtn.addEventListener('click', hideShowGen);

  pfCartCo.addEventListener('click', finalCartUpdate);
}


// Card Slide
const arrowsBoxes = document.querySelectorAll('.kh-pf-arrs');
const arrows = document.querySelectorAll('.kh-pf-arrs span');

let sliderBoxMain = document.querySelector('.kh-pf-opts-slider');

if (sliderBoxMain) {
  let sliderWidth = sliderBoxMain.offsetWidth;
  sliderWidth = sliderWidth - 14;

  document.querySelectorAll('.kh-pf-card').forEach(card => {
    card.style.width = `calc(${sliderWidth}px / 3)`;
  });

  arrowsBoxes.forEach(arrowsBox => {
    const slider = arrowsBox.parentElement.querySelector('.kh-pf-slider');
    const cardCount = Array.from(slider.children[0].children).length;
    const cardWidth = Number(slider.children[0].children[0].clientWidth);
    const conWidth = Number(slider.clientWidth);

    if ((cardWidth * cardCount) > conWidth) {
      arrowsBox.classList.add('rdc-active');
    }
  });

  let cardSlided = 0;

  const slideCards = function () {
    const isRight = this.classList.contains('kh-pf-r');
    const thisTarget = document.querySelector(`[data-id="${this.parentElement.dataset.for}"]`);

    const sliderBox = thisTarget.querySelector('.kh-pf-opts-slider');
    const thisSlider = thisTarget.querySelector('.kh-pf-options');
    const cards = thisSlider.querySelectorAll('.kh-pf-card');

    cardSlided = thisTarget.dataset.cardslided ? Number(thisTarget.dataset.cardslided) : 0;

    if (isRight) {
      if (cardSlided >= cards.length - 3) return;
      cardSlided = Math.min(cardSlided + 3, cards.length - 3);
    } else {
      if (cardSlided <= 0) return;
      cardSlided = Math.max(cardSlided - 3, 0);
    }

    thisSlider.style.transform = 'translateX(0px)';

    const sliderLeft = sliderBox.getBoundingClientRect().left;
    const cardLeft = cards[cardSlided].getBoundingClientRect().left;
    const runTransWidth = cardLeft - sliderLeft;

    thisTarget.setAttribute('data-cardslided', cardSlided);
    thisTarget.setAttribute('data-slidew', runTransWidth);

    thisSlider.style.transform = `translateX(-${runTransWidth}px)`;
  };

  arrows.forEach(arrow => arrow.addEventListener('click', slideCards));
}